import preImg from './preImg'
// import { moneyInput } from './moneyInput'

function install(Vue) {
  // Vue.directive('money-input', moneyInput)
  Vue.directive('pre-img', preImg)
}

export default install
